import React, { useState, useEffect, useRef } from "react";

import { collection, getDocs } from "firebase/firestore";
import { db } from "../firebase.js";

import ReturnImage from "../functions/image.js";

const Timeline = () => {

    const [timeList, setTimeList] = useState([]);
    const timeListRef = useRef([])
    const [title, setTitle] = useState("");
    const [desc, setDesc] = useState("");
    const [date, setDate] = useState("");
    const [job, setJob] = useState("");
    const [imageSrc, setImageSrc] = useState("");
    const [imageAlt, setImageAlt] = useState("");

    const collectionName = "timeline";
        
    async function getTimeLineEvents(event) {
        let allEvents = [];
        try {
            const querySnapshot = await getDocs(collection(db, collectionName));    

            querySnapshot.forEach((doc) => {
                let timelineEvent = doc.data();
                timelineEvent.id = doc.id;
                allEvents.push(timelineEvent);
            });
        } catch (error) {
            console.error("Erreur lors de la lecture des données:", error);
        }

        return allEvents;
    }

    function updateInfos(event) {
        // Ajout de la classe pour la transition en smooth
        document.querySelector(".timeline").classList.add("changeSmooth");

        // On récupère les attributs du bouton
        const button = event.currentTarget;
        const dataLogo = button.dataset.logo;
        button.classList.add("active");

        // Mise à jour des state
        setTimeout(() => {
            setTitle(timeList[dataLogo].title);
            setDesc(timeList[dataLogo].description);
            setDate(timeList[dataLogo].date);
            setJob(timeList[dataLogo].job);
            setImageSrc(timeList[dataLogo].image_src);
            setImageAlt(timeList[dataLogo].image_alt);
            document.querySelectorAll(".timeline-button").forEach(e => {
                e.classList.remove('active');
            });
        }, 100);

        // Fin de la transition smooth
        setTimeout(() => {
            document.querySelector(".timeline").classList.remove("changeSmooth");
        }, 400);
    }

    useEffect(() => {
        const list = getTimeLineEvents();
        getTimeLineEvents()
        .then(events => {
            setTimeList(events); // Mets à jour l'état avec le tableau
            setTitle(events[0].title);
            setDesc(events[0].description);
            setDate(events[0].date);
            setJob(events[0].job);
            setImageSrc(events[0].image_src);
            setImageAlt(events[0].image_alt);
            document.querySelector("timeline-button").classList.add("active");
        })
        .catch(error => {
            console.error("Erreur lors de la récupération des données:", error);
        });
    }, []);

    return (
        <div className="container-fluid timeline pt-4 pb-4 pt-lg-5 pb-lg-5" id="timeline">
            <div className="row timeline-container">
                <div className="col-4 col-sm-12 timeline-selectors d-flex flex-column align-items-center flex-sm-row">
                    {timeList.map((item, index) => (
                        <div className={`timeline-button timeline-${item.id}`} data-logo={index} id={index} onClick={updateInfos}>
                            <img className="timeline-logo" src={`${process.env.PUBLIC_URL}${item.logo_url}`} alt={item.logo_name} loading="lazy" />
                        </div>
                    ))}
                </div>
                <div className="col-8 col-sm-7 col-lg-6 timeline-infos text-white">
                    <div className="d-sm-flex align-items-center">
                        <h2 className="timeline-title">{title}</h2>
                        <span className="timeline-date">{date}</span>
                    </div>
                    <h3 className="timeline-function">Fonction : <span>{job}</span></h3>
                    <p className="timeline-paragraph" dangerouslySetInnerHTML={{ __html: desc }} />
                </div>
            </div>
            <ReturnImage
             imageName={imageSrc}
             classname="timeline-image"
             alt={imageAlt}
             viewport={100} />
        </div>
    )
}

export default Timeline;